import { NewsList, SingleNews } from '@toggle/toggle';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { ListDivider } from '~/components/list-divider/ListDivider';
import { NewsThumbnail } from '~/components/news-thumbnail/NewsThumbnail';
import { NewsLoadingState } from '~/views/news/components/news-loading-state/NewsLoadingState';

export interface NewsThumbnailListsProps {
  newsList: NewsList;
  prevRefetchTimestamp: Date;
  onSingleNewsClick: (singleNews: SingleNews) => void;
  highlighted?: string;
  isGrid?: boolean;
  isLoading: boolean;
}

export const NewsThumbnailLists = ({
  newsList,
  prevRefetchTimestamp,
  onSingleNewsClick,
  highlighted,
  isGrid,
  isLoading,
}: NewsThumbnailListsProps) => {
  const { t } = useTranslation('news');

  if (isLoading) {
    return <NewsLoadingState />;
  }

  return (
    <>
      {newsList.map((data, index) => {
        const prevRefetchTime = prevRefetchTimestamp.getTime();
        const newsTime = new Date(data.published).getTime();

        const isShowDivider =
          newsTime > prevRefetchTime &&
          newsList[index + 1]?.published &&
          new Date(newsList[index + 1].published).getTime() < prevRefetchTime;

        return (
          <Fragment key={data.id}>
            <NewsThumbnail
              newsData={data}
              prevRefetchTimestamp={prevRefetchTimestamp}
              onClick={onSingleNewsClick}
              highlighted={highlighted}
              isGrid={isGrid}
              showFullTimestamp={false}
            />
            {isShowDivider && <ListDivider label={t('news:divider')} />}
          </Fragment>
        );
      })}
    </>
  );
};
